export default class UmeLinks {
  static ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.ume&hl=pt_BR&gl=US'
  static STORE_APPLICATION_ANDROID_APP_URL = `${UmeLinks.ANDROID_APP_URL}&utm_source=application&utm_medium=qr_code&utm_campaign=br-site-crediario-application-novos_clientes-qr_code_application_tela_final_application`
  static QR_CODE_CAPTURE_METHOD_EXPLANATION_URL = `https://storage.googleapis.com/prd-static-files-api/da0a0db131b589907461eb12be5cb083.pdf`
}
